import throttle from '../base/_throttle.js';

export function calcFontSize( node, min, max ) {

	const computedStyle       = getComputedStyle( node );
	const parentComputedStyle = getComputedStyle( node.parentNode );
	const parentWidth         = node.parentNode.clientWidth - parseFloat( parentComputedStyle.paddingLeft ) - parseFloat( parentComputedStyle.paddingRight );
	const scrollWidth         = node.scrollWidth;
	const currentFontSize     = parseFloat( computedStyle.fontSize );
	const calcFontSize        = Math.floor( ( parentWidth / scrollWidth ) * currentFontSize );

	// let fontSize = parentWidth == scrollWidth ? 100 : calcFontSize;
	let fontSize = calcFontSize;

	if ( min && ! isNaN( Number( min ) ) ) {
		fontSize = Math.max( Number( min ), fontSize );
	}
	if ( max && ! isNaN( Number( max ) ) ) {
		fontSize = Math.min( Number( max ), fontSize );
	}
	return fontSize;
}

export class FitHtmlTextController {
	constructor( opts = {} ) {
		this.opts = {
			throttle: 10,
			observer: {
				characterData: true,
				subtree: true,
				childList: true,
			},
			...opts
		};

		this.observed = [];
		this.observer = new MutationObserver( this.resize.bind( this ) );
		window.addEventListener( 'load', throttle( this.resize.bind(this), this.opts.throttle ) );
		window.addEventListener( 'resize', throttle( this.resize.bind(this), this.opts.throttle ) );
	}

	resize() {
		this.observed.forEach( observed => observed.resize() );
	}

	add( nodes, opts = {} ) {
		if ( ! Array.isArray( nodes ) ) {
			if ( nodes instanceof HTMLElement ) {
				nodes = [ nodes ];
			} else if ( nodes instanceof NodeList ) {
				nodes = Array.from( nodes );
			} else if ( typeof nodes === 'string' ) {
				nodes = Array.from( document.querySelectorAll( nodes ) );
			} else {
				throw new Error( 'Invalid FitHtmlText Nodes', nodes );
			}
		}

		return nodes.filter( node => node instanceof HTMLElement && ! node.dataset.fitted ).map( n => {
			const fitHtmlText = new FitHtmlText( n, opts );

			this.observer.observe( fitHtmlText.node, this.opts.observer );
			this.observed.push( fitHtmlText );

			return fitHtmlText;
		} );

	}

	remove( node ) {
		const unobserved = this.observed.filter( n => n.node === node );

		unobserved.forEach( n => n.reset() );

		this.observed = this.observed.filter( n => ! unobserved.includes( n.node ) );
	}
}

export class FitHtmlText {
	constructor( node, opts = {} ) {
		this.node = node;
		this.opts = {
			min: this.node.dataset.minFontSize || 16,
			max: this.node.dataset.maxFontSize || 512,
			fittedClass: false,
			...opts
		};

		this.node.style.display  = 'inline-block';
		this.node.style.maxWidth = 'none';
		this.node.style.width    = 'none';
		this.node.dataset.fitted = true;
		this.node.classList.add(this.opts.fittedClass);


		setTimeout( this.resize.bind(this), 0 );
	}

	resize() {


		requestAnimationFrame( () => {
			const fontSize = calcFontSize( this.node, this.opts.min, this.opts.max );
			this.node.style.fontSize = `${ fontSize }px`;
			this.node.style.whiteSpace = fontSize === this.opts.min ? 'normal' : 'nowrap';

		} );
	}

	reset() {
		this.node.style.display    = '';
		this.node.style.fontSize   = '';
		this.node.style.maxWidth   = '';
		this.node.style.width      = '';
		this.node.style.whiteSpace = '';

		delete this.node.dataset.filled;
	}
}

export function fitHtmlText( node, opts = {} ) {
	if ( ! FitHtmlTextController.instance ) {
		FitHtmlTextController.instance = new FitHtmlTextController();
	}

	FitHtmlTextController.instance.add( node, opts );

	return FitHtmlTextController.instance;
}
